import { getDefaultUserAvatarUrl } from "./defaultUserAvatar";

export function hasUserProfileImage(profile) {
  return Boolean(profile?.profileName && profile?.profilePath);
}

export function getUserProfileImageDataUrl(profile) {
  if (!hasUserProfileImage(profile)) return null;
  return `data:image/${profile.profileName};base64,${profile.profilePath}`;
}

/** User photo first, then optional brand logo, then default avatar. */
export function resolveSidebarAvatarSrc(profile, brandLogoUrl = "") {
  const userSrc = getUserProfileImageDataUrl(profile);
  if (userSrc) {
    return { src: userSrc, variant: "user" };
  }
  const brand =
    typeof brandLogoUrl === "string" ? brandLogoUrl.trim() : "";
  if (brand) {
    return { src: brand, variant: "brand" };
  }
  return { src: getDefaultUserAvatarUrl(), variant: "default" };
}

export function readImageFileAsProfileFields(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const match = String(reader.result).match(
        /^data:image\/([^;]+);base64,(.+)$/,
      );
      if (!match) {
        resolve(null);
        return;
      }
      resolve({ profileName: match[1], profilePath: match[2] });
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
